import {bookingLocations,bookingPath,todayAtLocation} from './BookingLocationRoutes';
type SpaLocation={code:string;name:string;timezone:string;
 phone?:string|null;email?:string|null;address?:string|null};
/** Public /booking/locations selector from the owner FloatHelm screenshot.
 * The three location ID values are verified owner-supplied URL IDs.
 * Contact details are shown only when configured by the location manager.
 */
export function PublicLocationDirectory({locations,onChoose}:{
 locations:SpaLocation[];onChoose:(code:string)=>void;
}){
 return <section className="ecfs-public-location-directory"
   aria-label="Choose an East Coast Float Spa location">
   <h1>Choose Your Location</h1>
   <div className="ecfs-public-location-directory-grid">
     {locations.map(location=><article key={location.code}>
       <h2>East Coast Float Spa {location.name}</h2>
       {location.address&&<p>{location.address}</p>}
       {location.phone&&<p>Phone: <a href={'tel:'+location.phone}>
         {location.phone}</a></p>}
       {location.email&&<p>Email: <a href={'mailto:'+location.email}>
         {location.email}</a></p>}
       <a href={bookingPath(location.code,todayAtLocation(location.timezone))}
         onClick={event=>{event.preventDefault();onChoose(location.code);}}>
         Book at {location.name}
       </a>
       <small>Location {bookingLocations[location.code as keyof typeof bookingLocations]?.number}</small>
     </article>)}
   </div>
 </section>;
}
